<!-- User Information -->
<ion-card data-testid="profile-card" class="profile-card" (click)="handleOpenProfile()">
  <div class="card-content-wrapper">
    <ion-avatar class="avatar-circle">
      <span class="avatar-initials">{{ givenName$$() | userInitials : familyName$$() }}</span>
    </ion-avatar>
    <div class="card-text">
      <ion-card-title class="profile-name">{{ userFullName$$() }}</ion-card-title>
      <ion-card-content class="profile-email">{{ userEMail$$() }}</ion-card-content>
    </div>
    <ion-icon name="open-externally" class="action-icon" />
  </div>
</ion-card>
